<template>
  <div class="border px-l">
    <h2>Upload Images</h2>

    <b-form-file
      multiple
      v-model="chosen_files"
      accept="image/jpeg, image/png, image/gif"
      placeholder="Choose a file or drop it here..."
      drop-placeholder="Drop file here..."
    ></b-form-file>

    <p>Files to upload:</p>
    <b-list-group>
      <b-list-group-item
        v-for="file in chosen_files"
        :key="file.lastModified + file.name + file.size"
        class="d-flex justify-content-between align-items-center"
      >
        {{file.name}}
        <b-badge variant="primary">{{file.size | formatBytes}}</b-badge>
      </b-list-group-item>
    </b-list-group>
    <b-button :disabled="! chosen_files.length > 0" variant="primary" @click="upload">Upload</b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "@/js/utils.js";
import fb from "@/firebaseConfig";
import asset from "../js/asset";

export default {
  data() {
    return {
      chosen_files: []
    };
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  },
  filters: {
    formatBytes: function(value) {
      if (typeof value !== "number" || isNaN(value)) {
        return "NaN";
      }

      const units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const oom = Math.floor(Math.log(value) / Math.log(1024));
      value = (value / Math.pow(1024, oom)).toFixed(2);

      return value + " " + units[oom];
    }
  },
  methods: {
    upload() {
      for (const file of this.chosen_files) {
        const ref = fb.storage
          .ref()
          .child("assets")
          .child(utils.randomString(32));

        ref.put(file).then(snapshot => {
          console.log(snapshot);
          snapshot.ref.getDownloadURL().then(url => {
            const newAsset = new asset.Asset({
              URL: url,
              title: file.name,
              type: asset.AssetType.IMAGE,
              owners: [this.user.details.uid]
            });
            newAsset.fbSave();
          });
          this.chosen_files = this.chosen_files.filter(i => i !== file);
        });
      }
    }
  }
};
</script>

<style>
</style>